/*
|-------------------------------------------------------------------------------
| 优惠券信息管理
|-------------------------------------------------------------------------------
*/
import { defineStore, useState } from '~/utils/store'
import type { IStoreState } from '~/utils/store'
import { useI18n } from '~/utils/i18n'
import {
  queryMarketingBenefitSets,
  queryMarketActivityV2,
  queryGlobalBestActivity,
} from '@/api/coupon'
import {
  ACTIVITY_COUPON_TYPE,
  COUPON_TYPE,
  COUPONS_FLAG,
  HOME_BENEFITS_PAGE_LIST
} from '~/constants/coupons'
import { CASH_BACK_FLAG } from '~/constants/cashBack'
// 图片
import couponSimple from '~/assets/images/home/coupon-simple.png'
import couponTravelShadow from '~/assets/images/home/coupon-car-shadow.png'
import couponTakeawayShadow from '~/assets/images/home/coupon-food-shadow.png'


const couponsStore = defineStore({
  state: () => ({
    /**
     * 人群分组
     * WHITE00020001 默认组（阶段一）
     * WHITE00020002 空白组（阶段一）
     * WHITE00020003 实验组（阶段一）
     * WHITE00020004 实验一（阶段二）
     * WHITE00020005 实验二（阶段二）
     * WHITE00020006 实验三（阶段二）
     */
    group: 'WHITE00020001',

    /**
     * 卡片权益页面
     */
    firstPage: {
      // 开卡礼总金额
      totalAmt: '',

      // 开卡礼优惠券
      openCardList: [],

      // 刷卡礼优惠券
      consumptionCardList: [],
    },

    /**
     * 我的权益页面
     */
    detailPage: {
      // 开卡礼出行优惠券额度
      openTravelAmt: '',

      // 开卡礼外卖优惠券额度
      openTakeawayAmt: '',

      // 刷卡礼出行优惠券额度
      useTravelAmt: '',

      // 刷卡礼外卖优惠券额度
      useTakeawayAmt: '',

      // 开卡礼优惠券
      openCardList: [],

      // 刷卡礼优惠券
      consumptionCardList: [],
    },

    /**
     * 我的权益页面(迁移权益)
     */
    migrationBenefitsTotal: {
      // 优惠券总金额
      totalAmt: '',
    },

    /**
     * 我的权益页面(迁移权益)
     */
    migrationBenefitsDetail: {
      // 开卡礼出行优惠券额度
      openTravelAmt: '',

      // 开卡礼外卖优惠券额度
      openTakeawayAmt: '',

      // 开卡礼优惠券
      openCardList: [],
    },

    /**
     * 返现活动比例信息
     */
    activityInfos: [],

    /**
     * 返现活动最高比例
     */
    activityMaxRatio: '',

    /**
     * 返现活动固定返现金额
     */
    activityMaxAmtInfo: {
      activityMaxRatioFlag: null,
      activityMaxAmtDesc: '',
    },

    /**
     * 用户是否可以参与返现活动
     */
    isCashBack: false,

    /**
     * 用户关闭优惠活动
     */
    isClosePopup: false,

    /**
     * 用户展示优惠活动弹窗
     */
    isShowDialog: false,

    /**
     * 用户当前是否有有效活动
     */
    openCashBack: false,

    /**
     * 优惠券申请时间
     */
    applicationDate1: '',

    /**
     * 迁移优惠券申请时间
     */
    applicationDate2: '',

    /**
     * 迁移返现比例
     */
    cashBackPercent: '',

    /**
     * 立减权益
     */
    discountBenefits: {
      // 总额度
      totalDiscountAmt: '',

      // 出行额度
      travelDiscountAmt: '',

      // 外卖额度
      foodDiscountAmt: '',

      // 券展示控制标识
      discountBitmap: 0,

      // 活动有效期
      latestActivityExpiredTime: '',

      // 权益有效期
      latestRightsExpiredTime: '',

      // 立减券是否发放
      discountIssueFlag: false,

      // 立减券
      discountRightInfos: [],
    },
    // 新接口的立减 所有的数据
    discountRightDtoAll: [
      // {
      //   title: '',
      //   subTitle: '',
      //   iconUrl: '',
      //   /**
      //    * 立减权益
      //    */
      //   discountRightDto: {
      //     // 总额度
      //     totalDiscountAmt: '',
      //     totalDiscountDesc: '',
      //     // 出行额度
      //     travelDiscountAmt: '',
      //     // 外卖额度
      //     foodDiscountAmt: '',
      //     // 券展示控制标识
      //     discountBitmap: 0,
      //     // 活动有效期
      //     latestActivityExpiredTime: '',
      //     // 权益有效期
      //     latestRightsExpiredTime: '',
      //     // 立减券是否发放
      //     discountIssueFlag: false,
      //     // 立减券
      //     discountRightInfos: [],
      //   },
      // },
    ],

    /**
     * 优惠券展示标识
     * RIGHT1 / RIGHT2: 展示普通优惠券
     * RIGHT3: 展示迁移、普通优惠券
     * DISCOUNT：展示立减券
     */
    benefitsFlag: '',
    /**
     * esb营销信息,没有esb营销活动时
     * esbInfo值为null当存在esb活动时值为
     * 对象属性有：
     * target：目标金额
     * backAmt：返现金额
     *
    },
     */
    esbInfo: null,
    /**
     * 分期卷数据
     */
    installmentCouponDto: {
      /**
       * 领取情况
       * 1-领券,2-分期使用,3-过期
       */
      showScene: 0,
      /**
       * 最高比例
       */
      discountScale: 0,
      /**
       * 最高立减
       */
      maxDiscountValue: 0,
    },
    /**
     * MSI权益展示标识
     * 入口有两处：1、申卡首页-权益列表和权益说明（含预授信） 2、用卡首页-我的权益-MSI权益介绍
     * display true - 展示MSI权益说明，false - 不展示
     * maxPeriod integer msi 最大分期期数
     * interest msi 利息
     * availablePeriods 可用分期期数
     * merchants msi 商户列表
     * mcc msi导航栏
     * msiFaqs   msi，FAQ
     * protocol  msi通用协议
     */
    msiRightsAndInterestsResp: {
      display: false,
      availablePeriods: '',
      maxPeriod: '',
      interest: '',
      merchants: [],
      mcc: [],
      msiFaqs: [],
      protocol: '',
    },
    //表示有限时加码的返现比例
    hasTempCostDiscount: false,
    //没有立减开卡礼，但有返现时，顶部权益展示
    cashBackTopRights: false,
    //限时加码返现比例失效天数
    tempCostDiscountDay: 0,
    /**
     * 是否为sku返现
     */
    skuEnable: false,
    /*
    权益接口是否已经请求过
    */
    isRights: false,
    /*
    申卡权益
    */
    applyCardCoupeBannerResp: {
      configs: [],
    },
    //促销商户
    promotionMerchantsResp: {
      display: false, //是否展示
      title: '', //主标题
      introduction: '', //商户文案
      discountText: '', //折扣文案
      link: '', //配图
      merchants: [], // 商户列表
      mcc: [], //导航栏列表
      padFaqs: [], //FAQ
      protocol: '', //通用协议
    },

    //万事达权益
    mastercardResp: {
      display: false, //是否展示
      benefits: [], //万事达权益列表
    },
    // cashback返现 配置图标
    applyCardExtendMerchantsResp: {},

    // 权益包
    benefitPackInfo: {
      title: '',
      subTitle: '',
      icon: '',
      displayFlag: false, //是否展示
    },

    // 优惠卷活动
    couponInfo: {},

    // 用卡权益页banner列表
    bannerList: [],
    // 当前月份, 立减落地页使用
    currMonth: '',
    //新权益接口返回数据
    // 外投券
    rightsOut: {
      maxMSI: '',
    },
    //是否有权益
    hasRights: false,

     // 是否有全球精选活动
    hasGlobalBestActivity: false,
    dataGlobalBestActivity: {
      activityId: "", //活动 id,是 null 说明没有返现活动
      costDiscountType: 0, //返现类型：6 比例 / 5 固额
      costDiscount: 0, //比例/金额滴分
      maxMsiInstallment: 0, //用户最大的 msi 商户分期数
    },
  }),
  getters: {
    getCouponsShadowList(state) {
      // 调整优惠券样式
      const getOpenCardList: any[] = []

      state.firstPage.openCardList.forEach((item: any) => {
        const itemD = { ...item }
        if (itemD.couponType === 'travel') {
          // 设置优惠券样式
          itemD.bgUrl = couponTravelShadow
          itemD.width = '50%'
        } else if (itemD.couponType === 'takeaway') {
          // 设置优惠券样式
          itemD.bgUrl = couponTakeawayShadow
          itemD.width = '50%'
        }
        getOpenCardList.push(itemD)
      })
      return getOpenCardList
    },

    /**
     * 获取立减券
     */
    getVoucherList(state) {
      // 调整优惠券样式
      const getOpenCardList: any[] = []

      const { currency } = useState('common', ['currency'])

      state.discountBenefits.discountRightInfos.forEach(
        (item: any) => {
          const itemD = { ...item }
          // 设置优惠券样式
          itemD.bgUrl = couponSimple
          itemD.width = '48.5%'
          itemD.textColor = '#5344FC'
          itemD.type = 0
          itemD.opacity = '1'
          itemD.discount = item?.discountAmt
          itemD.moneyUnit = currency
          itemD.amount = `${useI18n().t(
            'financial.loan.baldr.credit.benifit.discount.left',
            {
              num: item?.currentCount,
            }
          )}`

          if (item?.businessId === COUPON_TYPE.TRAVEL) {
            itemD.title = `Viajes en DiDi  (${useI18n().t(
              'financial.loan.baldr.credit.benifit.discount.total',
              {
                num: item?.totalCount,
              }
            )})`
          } else if (
            item?.businessId === COUPON_TYPE.TAKEAWAY
          ) {
            itemD.title = `DiDi Food (${useI18n().t(
              'financial.loan.baldr.credit.benifit.discount.total',
              {
                num: item?.totalCount,
              }
            )})`
          }
          getOpenCardList.push(itemD)
        }
      )
      return getOpenCardList
    },
    /**
     * 是否命中开卡礼，目前无实验控制
     */
    isOpenGift(state) {
      const isVoucher =
        state?.benefitsFlag === COUPONS_FLAG.DISCOUNT

      return isVoucher
    },
    /**
     * 获取开卡礼金额
     */
    openCardTotalAmt(state) {
      // 是否命中立减券
      const isVoucher =
        state?.benefitsFlag === COUPONS_FLAG.DISCOUNT

      // 立减券总金额
      const discountAmt =
        state?.discountBenefits?.totalDiscountAmt

      if (isVoucher) {
        return discountAmt
      } else {
        return ''
      }
    },
    // 是否展示msi权益
    isShowMsi(state) {
      return state?.msiRightsAndInterestsResp?.display
    },
    msiConfig(state) {
      return state?.msiRightsAndInterestsResp
    },
    // 我的权益中展示mis前三个商户
    myRightsMsi(state) {
      return (
        state.msiRightsAndInterestsResp?.merchants || []
      ).slice(0, 3)
    },

    //申请卡权益列表
    applyRightsList(state) {
      return state.applyCardCoupeBannerResp?.configs || []
    },

    // 是否有促销商户
    isShowPromotion(state) {
      return state?.promotionMerchantsResp?.display
    },
    // 我的权益中展示促销商户前三个商户
    myRightsPromotion(state) {
      return (
        state?.promotionMerchantsResp?.merchants || []
      ).slice(0, 3)
    },

    // 促销商户落地页头部信息
    promotionHeadInfo(state) {
      const data = state?.promotionMerchantsResp
      return {
        title: data?.title || '',
        introduction: data?.introduction || '',
        discountText: data?.discountText || '',
        link: data?.link || '',
      }
    },
    //是否有万事达
    isShowBenefits(state) {
      return state.mastercardResp?.display
    },
    //万事达
    benefitsList(state) {
      return state.mastercardResp?.benefits || []
    },
    // 区分不同页面文案的展示
    benefitsFlag(state) {
      let rightsText = ''
      const { homePageStatus } = useState('home', ['homePageStatus'])
      const isHomePageShow = HOME_BENEFITS_PAGE_LIST.includes(homePageStatus)
      // 端外一阶段等待首页、端外一阶段通过首页
      if (state.rightsOut && state.rightsOut.maxMSI) {
        if (isHomePageShow) {
          rightsText = useI18n().t(
            "Fintech_Credit_channel_vMjf_icCB",
            { number: state.rightsOut.maxMSI }
          ) as string
        } else {
          rightsText = useI18n().t(
            "Fintech_Credit_channel_rMuR_LyuJ",
            { number: `<span style="font-family:DiDiSans-Pro-Bold;color:#FF8040;">${state.rightsOut.maxMSI}</span>` }
          ) as string
        }
      }
      return rightsText
    },
  },
  mutations: {
    saveGroup(state, group: string) {
      state.group = group
    },
    saveCashBackIcon(state, data) {
      state.applyCardExtendMerchantsResp = data
    },
    saveCouponInfo(state, data) {
      state.couponInfo = data
    },
    saveFlag(state, isCashBack: string) {
      state.isCashBack = isCashBack === CASH_BACK_FLAG.ABLE
    },
    saveRatio(state, activityInfos) {
      state.activityInfos = activityInfos
    },
    saveMaxRatio(state, maxRatio: string) {
      state.activityMaxRatio = maxRatio
    },
    saveMaxAmt(state, data) {
      state.activityMaxAmtInfo = data
    },
    setHasTempCostDiscount(state, data) {
      state.hasTempCostDiscount =
        data?.hasTempCostDiscount == 'Y' ? true : false
      state.tempCostDiscountDay = data?.tempCostDiscountDay
    },
    saveMigrationBenefitsDetail(state, page) {
      Object.assign(state.migrationBenefitsDetail, page)
    },

    saveMigrationBenefitsTotal(state, page) {
      Object.assign(state.migrationBenefitsTotal, page)
    },

    saveDiscountBenefits(state, item) {
      Object.assign(state.discountBenefits, item)
    },
    saveDiscountRightDtoAll(state, item) {
      Object.assign(state.discountRightDtoAll, item)
    },

    saveBenefitsFlag(state, flag) {
      state.benefitsFlag = flag
    },

    update(state, item) {
      Object.assign(state, item)
    },

    // 设置权益动画弹窗关闭
    saveClosePopup(state, isClose: boolean) {
      state.isClosePopup = isClose
    },

    // 设置权益动画弹窗显示
    saveShowDialog(state, isShow: boolean) {
      state.isShowDialog = isShow
    },

    // 设置刷卡礼可用
    changeConsumptionCardList(state) {
      state.detailPage.consumptionCardList.forEach(
        (element: any) => {
          element.opacity = '1'
        }
      )
    },
    // 用来判断返现当前是否有有效活动
    saveCashBackStatus(state, openCashBack: string) {
      state.openCashBack =
        openCashBack === CASH_BACK_FLAG.ABLE
    },
    // esb
    saveEsbInfo(state, info) {
      state.esbInfo = info
    },
    // msi权益
    saveMsiDisplayFlag(state, obj) {
      Object.assign(state.msiRightsAndInterestsResp, obj)
    },
    // 设置没有立减开卡礼，但有返现时，顶部权益部分展示
    saveCashBackTopRights(state) {
      state.cashBackTopRights = true
    },
    //是否为sku活动
    saveskuEnableFlag(state, value) {
      state.skuEnable = value
    },
    //权益接口请求状
    saveiIsRights(state, flag) {
      state.isRights = flag
    },
    //申请卡权益配置
    saveApplyCardCoupeBannerResp(state, info) {
      state.applyCardCoupeBannerResp = info
    },
    //促销商户
    savePromotionMerchantsResp(state, info) {
      state.promotionMerchantsResp = info
    },
    //万事达
    saveMastercardResp(state, info) {
      state.mastercardResp = info
    },
    //权益包
    saveBenefitPackInfo(state, info) {
      state.benefitPackInfo = info
    },
    // 分期卷数据
    saveInstallmentCouponDto(state, info) {
      state.installmentCouponDto = info
    },
    // 用卡权益页banner数据
    saveBannerList(state, info) {
      state.bannerList = info
    },
    // 当前月份, 立减页使用
    saveCurrMonth(state, info) {
      state.currMonth = info
    },
    saveRightsOut(state, data) {
      state.rightsOut = data
    },
    saveHasRights(state, data) {
      state.hasRights = data
    },
    saveHasGlobalBestActivity(state, data) {
      state.hasGlobalBestActivity = data;
    },
    saveDataGlobalBestActivity(state, data) {
      Object.assign(state.dataGlobalBestActivity, data);
    },
  },
  actions: {
    async getUserGroup(store, params) {
      try {
        const result = await queryMarketingBenefitSets({
          ...params,
        }, { loading: false }) as any

        const {
          bannerList,
          couponInfo,
          applyCardExtendMerchantsResp,
          applyCardCoupeBannerResp,
          msiRightsAndInterestsResp,
          promotionMerchantsResp,
          cashBackMarketingActivityInfo,
          benefitPackInfo,
          mastercardResp,
          currMonth,
        } = result.data

        // 立减权益数据
        let discountRightDto = null
        if (bannerList && bannerList.length > 0) {
          const bannerDiscount = bannerList.filter(
            (item: any) =>
              item.bannerType?.includes(
                ACTIVITY_COUPON_TYPE.DISCOUNT
              )
          )

          if (
            bannerDiscount &&
            bannerDiscount.length > 0
          ) {
            // 申卡的立减会将出行和外卖分成两条数据，且bannerType分别是DISCOUNT_TRAVEL、DISCOUNT_TAKEWAY
            // 此两条数据的discountRightDto是相同的，所以discountRightDto取了bannerDiscount[0]的数据
            store.commit(
              'saveDiscountRightDtoAll',
              bannerDiscount
            )
            discountRightDto =
              bannerDiscount[0]?.discountRightDto

            if (discountRightDto) {
              // 设置立减权益
              store.commit(
                'saveDiscountBenefits',
                discountRightDto
              )

              // 设置优惠券展示标识
              store.commit(
                'saveBenefitsFlag',
                ACTIVITY_COUPON_TYPE.DISCOUNT
              )
            }
          }
        }

        //若用户没有立减开卡礼，但有返现时，顶部权益部分展示返现权益
        if (
          !discountRightDto &&
          cashBackMarketingActivityInfo
        ) {
          store.commit('saveCashBackTopRights')
        }

        // cashback返现 配置图标
        store.commit(
          'saveCashBackIcon',
          applyCardExtendMerchantsResp
        )

        // 优惠券活动
        store.commit('saveCouponInfo', couponInfo)

        // 设置用户是否可以参与返现活动
        store.commit(
          'saveFlag',
          cashBackMarketingActivityInfo?.hitCashBack
        )

        // 设置用户返现活动比例
        store.commit(
          'saveRatio',
          cashBackMarketingActivityInfo?.activityRuleInfos ||
          []
        )

        // 设置用户返现活动最高比例
        store.commit(
          'saveMaxRatio',
          cashBackMarketingActivityInfo?.activityMaxRatio
        )
        // 设置用户返现活动最高比例
        store.commit('saveMaxAmt', {
          activityMaxAmt:
            cashBackMarketingActivityInfo?.activityMaxAmt,
          activityMaxAmtDesc:
            cashBackMarketingActivityInfo?.activityMaxAmtDesc,
          activityMaxRatioFlag:
            cashBackMarketingActivityInfo?.activityMaxRatioFlag,
        })
        // cashback 开户标识，1开户2未开户
        store.commit(
          'saveCashBackStatus',
          cashBackMarketingActivityInfo?.openCashBack
        )

        //是否展示限时加码的返现比例
        store.commit(
          'setHasTempCostDiscount',
          cashBackMarketingActivityInfo
        )
        // 设置msi权益展示标识
        if (msiRightsAndInterestsResp) {
          store.commit(
            'saveMsiDisplayFlag',
            msiRightsAndInterestsResp
          )
        }
        //是否为sku活动
        store.commit(
          'saveskuEnableFlag',
          cashBackMarketingActivityInfo?.skuEnable
        )
        if (applyCardCoupeBannerResp) {
          store.commit(
            'saveApplyCardCoupeBannerResp',
            applyCardCoupeBannerResp
          )
        }
        if (promotionMerchantsResp) {
          store.commit(
            'savePromotionMerchantsResp',
            promotionMerchantsResp
          )
        }
        if (mastercardResp) {
          store.commit(
            'saveMastercardResp',
            mastercardResp
          )
        }

        if (benefitPackInfo) {
          store.commit(
            'saveBenefitPackInfo',
            benefitPackInfo
          )
        }

        if (bannerList) {
          store.commit('saveBannerList', bannerList)
        }

        store.commit('saveCurrMonth', currMonth)
        store.commit('saveiIsRights', true)

      } catch (error) {
        /**
         * 获取用户权益分组接口失败处理
         * 1. 不影响后续流程
         * 2. 给用户展示空白组
         * 3. 上报错误埋点
         */
        return Promise.resolve()
      }
    },
    /**
     *
     * @description 新的权益接口获取数据
     */
    async getNewUserGroup(store, params) {
      try {
        store.commit('saveRightsOut', {})
        store.commit('saveHasRights', false)
        const { source, activityId, outFromPage, clientSource } = params
        const { data } = await queryMarketActivityV2({
          source,
          activityId,
          outFromPage,
          clientSource,
        }) as { data: api_openCard_queryOpenCardBenefits.Response }
        if (data && data.outCouponMaxActivityInfo && data.outCouponMaxActivityInfo.maxMSI) {
          store.commit('saveHasRights', true)
          store.commit(
            'saveRightsOut',
            data.outCouponMaxActivityInfo
          )
        }
      } catch (error) {
        store.commit('saveRightsOut', {})
        store.commit('saveHasRights', false)
      }
    },


    /**
     * @description 获取用户全局最优返现信息
     */
    async queryGlobalBestActivity(store, params) {
      try {
        if (store.state.hasGlobalBestActivity) return;
        store.commit("saveHasGlobalBestActivity", false);
        const { data } = await queryGlobalBestActivity({
          source: "APPLY_CARD",
        });
        if (data && Object.keys(data).length) {
          store.commit("saveHasGlobalBestActivity", true);
          store.commit("saveDataGlobalBestActivity", data);
        } else {
          store.commit("saveHasGlobalBestActivity", false);
        }
      } catch (error) {
        store.commit("saveHasGlobalBestActivity", false);
      }
    },
  },
})
export default couponsStore
export type ICouponsStoreState = IStoreState<
  typeof couponsStore.state
>
